import React from "react";

// Simple horizontal pill tab switcher.
// tabs: [{ id, label, count? }], active: id, onChange: (id) => void
export default function PillTabs({ tabs = [], active, onChange, className = "" }) {
  return (
    <div className={`mb-5 flex flex-wrap gap-2 border-b border-[#e4e4e4] pb-3 ${className}`}>
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition ${
              isActive
                ? "bg-[#1100EF] text-white"
                : "bg-[#f4f4f6] text-[#555] hover:bg-[#ecebff] hover:text-[#210EEB]"
            }`}
          >
            {tab.label}
            {typeof tab.count === "number" && (
              <span
                className={`ml-2 rounded-full px-1.5 py-0.5 text-xs ${
                  isActive ? "bg-white/25 text-white" : "bg-white text-[#777]"
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
